export const fuelListHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Created date",
		value: "crated_date",
		valueFilter: "filter_crated_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false
	},
	{
		settings: true,
		text: "Create by",
		value: "created_by",
		valueFilter: "filter_created_by",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Card",
		value: "card",
		valueFilter: "filter_card",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'note', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Transaction date",
		value: "fuel_date",
		valueFilter: "filter_fuel_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false
	},
	{
		settings: true,
		text: "Invoice",
		value: "invoice",
		valueFilter: "filter_invoice",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'note', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Driver",
		value: "driver",
		valueFilter: "filter_driver",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Truck",
		value: "truck_number",
		valueFilter: "filter_truck_number",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: "filter_customer",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Odometr",
		value: "odometr",
		valueFilter: "filter_odometr",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Location",
		value: "location",
		valueFilter: "filter_location",
		func: true,
		filterable: false,
		sortable: false,
		model: { value: 'note', },
		left: false
	},
	{
		settings: true,
		text: "City",
		value: "city",
		valueFilter: "filter_city",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "State/Prov",
		value: "state",
		valueFilter: "filter_state",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Fees",
		value: "fees",
		valueFilter: "filter_fees",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Item",
		value: "item",
		valueFilter: "filter_item",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Unit price",
		value: "unit",
		valueFilter: "filter_unit",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Disc PPU",
		value: "ppu",
		valueFilter: "filter_ppu",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Disc cost",
		value: "cost",
		valueFilter: "filter_cost",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Gallons",
		value: "gallons",
		valueFilter: "filter_gallons",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: true,
		footer: "sum",
		gallons: true
	},
	{
		settings: true,
		text: "Disc AMT",
		value: "amt",
		valueFilter: "filter_amt",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Disc type",
		value: "discType",
		valueFilter: "filter_discType",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: true,
		footer: "sum",
		dollar: true
	},
	{
		settings: true,
		text: "DB",
		value: "db",
		valueFilter: "filter_db",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Currency",
		value: "currency",
		valueFilter: "filter_currency",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		sticky: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];
